export default __webpack_public_path__ + "static/media/Goremonger's Leggings.ae947bca.jpg";